import React from "react";
import ReactDOM from "react-dom";
import App from './App';
import 'lib-flexible/flexible';
ReactDOM.render(
    <App />,
    document.querySelector("#root")
);
// console.info(Root)

console.log('————ops构建调试-childrenPrivacyAgreement————')